<template>
	<el-header style="text-align: right; font-size: 12px">
		<el-menu  
			mode="horizontal"
			background-color="#fff"
			text-color="#303133"
			active-text-color="#303133">
			<el-menu-item index="0" @click="toggle()"><i class="fa fa-bars fa-2x"></i></el-menu-item>
		</el-menu>
	</el-header>
</template>
<script>
import { LOGOUT } from "@/store/actions.type";
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      desconectar() {
          this.$store.dispatch(LOGOUT).then(() => {
              this.$router.push('/login');
          });
	  },
	  toggle() {
		  this.$root.$emit("toogleChange", true);
	  }
    }
  }

</script>
<style lang="scss" scoped>
	.el-header {
    padding: 0;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    background: white;
    z-index: 1;
    position: fixed;
    width: 100%;
		.menu__custom {
			float: right;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/TopNavbar.vue